import { removeIncompatibleSearchParameters } from "@helpers/removeIncompatibleSearchParameters"
import {
	seempPageSearchSchema,
	validateSeempSearchParams,
} from "@routes/clients.$clientName/_sopPageLayout/seemp"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/_sopPageLayout/seemp")({
	component: RouteComponent,
	validateSearch: validateSeempSearchParams,
	search: {
		middlewares: [removeIncompatibleSearchParameters(seempPageSearchSchema)],
	},
})

function RouteComponent() {
	return null
}
